import React from "react";

function SvgIcMapPoi133(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M24 25a2 2 0 012 2H6a2 2 0 012-2zM16 3a.5.5 0 01.5.5V4l6 2-6 2v2.025c3.632.258 6.5 3.278 6.5 6.975v6h-3v-6h-2v6h-4v-6h-2v6H9v-6l.004-.24c.12-3.587 2.944-6.483 6.496-6.735V3.5A.5.5 0 0116 3z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi133;
